import BookingBar from './BookingBar';

export default BookingBar;
